module.exports = __webpack_public_path__ + "img/south-africa.df1a1208.png";